module.exports = __webpack_public_path__ + "static/assets/eef0c5e9761d7850485979484434754c.gif";